<div class="container-fluid">
    <div class="row d-md-none mb-3">
        <div class="col">
            <nav class="nav flex-column">
                <button class="btn btn-secondary p-1" (click)="sidebarHiddenOnMobile = !sidebarHiddenOnMobile">
                    <i *ngIf="sidebarHiddenOnMobile" class="bi bi-chevron-expand"></i>
                    <i *ngIf="!sidebarHiddenOnMobile" class="bi bi-chevron-contract"></i>
                    {{sidebarHiddenOnMobile ? 'Show Articles' : 'Hide Articles'}}
                </button>
            </nav>
        </div>
    </div>
    <div class="row">
        <div [ngClass]="{'d-none d-md-flex': sidebarHiddenOnMobile}" class="col-12 col-md-2">
            <nav class="nav flex-column">
                <a *ngFor="let article of articleList" class="p-1 nav-link" [href]="'articles/' + article.url">{{article.title}}</a>
            </nav>
        </div>
        <div class="col-12 d-md-none">
            <hr />
        </div>
        <div class="col-12 col-md-10" [innerHtml]="articleContent"></div>
    </div>
</div>